@if (!isReport) {
  <div class="mb-3">
    <lib-card>
      <lib-card-body>
        @if (data) {
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <lib-button
                id="data-analysis-back"
                class="mr-2"
                [size]="'custom'"
                [height]="32"
                [fontSize]="18"
                [align]="'left'"
                [color]="'primary-link'"
                [faIcon]="'far fa-arrow-left'"
                (click)="showConfirmPopup(exitConfirmationTemplate, 'back')">
              </lib-button>
              @if (!modifyTitleMode) {
                <h6
                  class="font-weight-bold text-primary d-flex align-items-center m-0 font-size-medium-small">
                  {{data.name}}
                </h6>
              }
              @if (modifyTitleMode) {
                <input type="text" class="form-control" [(ngModel)]="data.name">
              }
              @if (!modifyTitleMode) {
                <lib-button
                  id="data-analysis-back"
                  [disabled]="loadingUpdate"
                  [label]="'DATA_STUDIO.DATA_ANALYSIS.EDIT_TITLE' | translate"
                  class="mr-2 modify-button"
                  [fontSize]="18"
                  [align]="'left'"
                  [color]="'primary-link'"
                  (click)="modifyTitle(true)" >
                </lib-button>
              }
              @if (modifyTitleMode) {
                <lib-button
                  id="data-analysis-back"
                  [disabled]="loadingUpdate"
                  [label]="'BUTTONS.SAVE' |translate"
                  class="mr-2 modify-button"
                  [fontSize]="18"
                  [align]="'left'"
                  [color]="'primary-link'"
                  (click)="modifyTitle(false)" >
                </lib-button>
              }
            </div>
            <div class="d-flex">
              @if (updateFlag) {
                <div class="pl-3 pr-2">
                  <lib-button
                    id="data-analysis-cancel-button"
                    [color]="'secondary'"
                    [label]="'BUTTONS.CANCEL' |translate"
                    (buttonClicked)="showConfirmPopup(cancelConfirmationTemplate, 'cancel')" >
                  </lib-button>
                </div>
                <div class="pr-3">
                  @if (series?.length > 0) {
                    <lib-button
                      id="data-analysis-save-button"
                      [label]="'BUTTONS.SAVE' |translate"
                      (buttonClicked)="save()" >
                    </lib-button>
                  }
                </div>
              }
            </div>
          </div>
        }
      </lib-card-body>
    </lib-card>
  </div>
  <lib-card>
    @if (series?.length > 0) {
      <lib-card-header>
        <div class="row justify-content-between">
          <div class="none"></div>
          <app-data-studio-period
            [ngClass]="{'custom-period-margin': activeView === 1}"
            [hidePeriodSelector]="activeView === 1"
            [startTs]="startTs"
            [endTs]="endTs"
            [periodLabel]="periodLabel"
            [disabled]="loadingUpdate"
            (changePeriod)="updateDate($event)">
          </app-data-studio-period>
          <div class="right-section d-flex">
            <div class="btn-group mr-2 {{theme$ | async}}">
              @if (exportOptions && activeView === 0) {
                <lib-select
                  [options]="exportOptions"
                  [label]="'BUTTONS.EXPORT' |translate"
                  [border]="'custom-border'"
                  [classes]="'font-size-normal-small text-primary h-100 text-left'"
                  [withIcon]="true"
                  [notBold]="true"
                  [fullWidth]="true"
                  [itemClasses]="'font-size-normal-small'"
                  [doNotTranslate]="true"
                  [container]="''"
                  [disabled]="loadingUpdate"
                  [size]="'small'"
                  (selectedChanged)="exportChart($event)">
                  <ng-container icon>
                    <i class="far fa-download font-icons pointer mr-2"></i>
                    <span class="pointer" > {{ (customLabel || 'BUTTONS.EXPORT') | translate}} </span>
                  </ng-container>
                </lib-select>
              }
            </div>
            <lib-content-box-buttons
              [active]="activeView"
              [buttons]="views"
              [ngClass]="{'disabled': loadingUpdate}"
              (activeChanged)="selectedView($event)">
            </lib-content-box-buttons>
          </div>
        </div>
      </lib-card-header>
    }
    <lib-card-body [fullContent]="activeView === 0">
      @if (activeView === 0) {
        <ng-template [ngTemplateOutlet]="chartview"></ng-template>
      }
      @if (activeView === 1) {
        <ng-template [ngTemplateOutlet]="tableview"></ng-template>
      }
    </lib-card-body>
  </lib-card>
}

@if (isReport) {
  @if (!signalsData?.data?.length) {
    <app-loading-and-no-data-template
      [height]="400"
      [isLoading]="loadingUpdate"
    ></app-loading-and-no-data-template>
  }
  @if (signalsData?.data?.length) {
    <div class="m-2">
      <app-scatter-plot-signals-chart
        [signalsData]="signalsData"
        [removeItems]="removeItems"
        [loading]="loadingUpdate"
        [updateSeriesList]="updateSeriesList"
        [xAxisMin]="xAxisMin"
        [xAxisMax]="xAxisMax"
        [exportChartOption$]="exportChartOption$"
        [isReport]="isReport"
        (dataJSONToExport)="exportJSON($event)"
        (updated)="updated()"
        (chartAxisUpdated)="chartAxisUpdated()"
      ></app-scatter-plot-signals-chart>
    </div>
  }
}

<ng-template #chartview>
  @if (!signalsData?.data?.length) {
    <app-loading-and-no-data-template
      [height]="400"
      [isLoading]="loadingUpdate"
    ></app-loading-and-no-data-template>
  }
  @if (signalsData?.data?.length) {
    <div class="m-2 p-2">
      <app-scatter-plot-signals-chart
        [signalsData]="signalsData"
        [removeItems]="removeItems"
        [updateSeriesList]="updateSeriesList"
        [xAxisMin]="xAxisMin"
        [xAxisMax]="xAxisMax"
        [exportChart$]="exportChart$"
        (updated)="updated()"
        (chartAxisUpdated)="chartAxisUpdated()"
      ></app-scatter-plot-signals-chart>
    </div>
  }
  @if (data) {
    <div class="m-2 d-flex align-items-center">
      <ng-template [ngTemplateOutlet]="options"></ng-template>
    </div>
  }
  @if (!filteredSeries?.length && series?.length > 0) {
    <app-loading-and-no-data-template
      [height]="150"
      [noDataLabel]="'No matching series. Please, try modifying the filter'"
      [isLoading]="loadingSignalList"
    ></app-loading-and-no-data-template>
  }
  @if (filteredSeries?.length > 0) {
    <div class="my-3">
      <app-scatter-plot-series-list
        [series]="filteredSeries"
        [granOptions]="granOptions"
        [loadingSerie]="loadingSerie"
        [theme]="theme$ | async"
        [disabled]="allSeriesUpdateMode || loadingUpdate"
        [saving]="savingData"
        (updateSerie)="updateSerie($event)"
        (deleteSeries)="deleteSeries($event)"
        (changeVisibility)="changeVisibility($event)"
      ></app-scatter-plot-series-list>
    </div>
  }
  <div #newseriescard>
    @if (creatingSeries) {
      <div class="m-3">
        <app-new-scatter-plot
          [parks]="parks"
          [ids]="seriesIds"
          [xUnit]="xUnit"
          (closeNew)="closeNew()"
          (createNew)="createNew($event)"
        ></app-new-scatter-plot>
      </div>
    }
  </div>
</ng-template>
<ng-template #tableview>
  <app-series-table
    [series]="series" [loading]="loadingUpdate"
    type="scatter-plot"
  ></app-series-table>
</ng-template>

<ng-template #options>
  @if (series?.length > 0) {
    <div class="px-3 font-weight-bold text-primary font-size-small">
      {{'DATA_STUDIO.DATA_ANALYSIS.TOTAL' | translate }}: {{series?.length}}  {{'DATA_STUDIO.DATA_ANALYSIS.SERIES' | translate }}
    </div>
    <div class="px-3">
      <lib-search
        placeholder="DATA_STUDIO.DATA_ANALYSIS.SEARCH_FOR_SERIES"
        [value]="searchValue"
        (inputChanged)="searchString($event)">
      </lib-search>
    </div>
    @if (confirmDelete) {
      <div class="px-3">
        <span class="text-primary mr-2 font-size-small">
          {{ "DATA_STUDIO.DATA_PARAMETERS.GRANULARITY" |translate }}
        </span>
        <lib-select
          [options]="granOptions.names"
          [label]="granLabel"
          [border]="'custom-border'"
          [classes]="'font-size-normal-small text-primary h-100'"
          [itemClasses]="'font-size-normal-small'"
          [doNotTranslate]="true"
          [container]="''"
          (selectedChanged)="selectGran($event)">
        </lib-select>
      </div>
    }
  }
  <div class="pl-3 pr-2">
    @if (!allSeriesUpdateMode && !confirmDelete) {
      <lib-button
        id="data-analysis-add-button"
        [color]="'secondary'"
        [label]="'DATA_STUDIO.DATA_ANALYSIS.ADD' | translate"
        (buttonClicked)="addSeries()" >
      </lib-button>
    }
    @if (allSeriesUpdateMode) {
      <lib-button
        id="data-analysis-cancel-button"
        [color]="'secondary'"
        [label]="'BUTTONS.CANCEL' |translate"
        (buttonClicked)="cancelSeriesUpdate()" >
      </lib-button>
    }
  </div>
  <div class="pr-3">
    @if (confirmDelete) {
      <lib-button
        id="data-analysis-delete-selected-button"
        [label]="'Delete Selected'"
        (buttonClicked)="deleteSelected()" >
      </lib-button>
    }
  </div>
  @if (loadingUpdate && series?.length > 0) {
    <div class="d-flex justify-content-center align-items-center" >
      {{ "COMMON.LOADING" |translate }}
      <app-spinner class="ml-2 mb-1"></app-spinner>
    </div>
  }
</ng-template>


<ng-template #exitConfirmationTemplate>
  <div class="modal-body text-center events-delete-modal p-3">
    <div class="row d-flex justify-content-between">
      <div>{{ "DATA_STUDIO.DATA_ANALYSIS.EXIT_MESSAGE" | translate}}</div>
    </div>
    <div class="row d-flex justify-content-end mt-4">
      <lib-button
        id="events-table-modal-cancel-button"
        class="mr-2"
        [color]="'secondary'"
        [label]="'BUTTONS.CANCEL' |translate"
        (buttonClicked)="closeModal()" >
      </lib-button>
      <lib-button
        id="events-table-modal-confirm-button"
        [label]="'BUTTONS.CONFIRM' |translate"
        (buttonClicked)="backToQueriesList()" >
      </lib-button>
    </div>
  </div>
</ng-template>

<ng-template #cancelConfirmationTemplate>
  <div class="modal-body text-center events-delete-modal p-3">
    <div class="row d-flex justify-content-between">
      <div>{{ "DATA_STUDIO.DATA_ANALYSIS.DISCARD_CHANGES_MESSAGE" | translate }}</div>
    </div>
    <div class="row d-flex justify-content-end mt-4">
      <lib-button
        id="events-table-modal-cancel-button"
        class="mr-2"
        [color]="'secondary'"
        [label]="'BUTTONS.CANCEL' |translate"
        (buttonClicked)="closeModal()" >
      </lib-button>
      <lib-button
        id="events-table-modal-confirm-button"
        [label]="'BUTTONS.CONFIRM' |translate"
        (buttonClicked)="cancel()" >
      </lib-button>
    </div>
  </div>
</ng-template>
